import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    navbarHeading: 'Nest Portal',
    dashboardApiData: []

}

const filterSlice = createSlice({
    name: 'filter',
    initialState,
    reducers: {
        updateNavbarHeading: (state, action) => {
            state.navbarHeading = action.payload
        },
        updateDashboardApiData: (state, action) => {
            state.dashboardApiData = action.payload
        },
    }
})


export const { updateNavbarHeading, updateDashboardApiData } = filterSlice.actions;
export default filterSlice.reducer;